import { render, staticRenderFns } from "./budget-proposal-back-page.vue?vue&type=template&id=1d007673&"
import script from "./budget-proposal-back-page.vue?vue&type=script&lang=js&"
export * from "./budget-proposal-back-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports